import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function Pricing() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Monnaify Pricing</h1>
          <p className="legal-meta">Last updated: 2026-04-21</p>
        </div>

        <p>
          Monnaify Pro gives you advanced features like unlimited houses, spending limits,
          analytics, and export options. Plans renew automatically until canceled.
        </p>

        <h2>Plans</h2>
        <ul>
          <li>Monthly: 39 TRY / month (0.99 USD / month, auto-renewing)</li>
          <li>Yearly: 279 TRY / year (4.99 USD / year, auto-renewing)</li>
        </ul>

        <h2>Billing and Renewal</h2>
        <ul>
          <li>Payment is charged at confirmation of purchase.</li>
          <li>Subscriptions renew automatically unless canceled at least 24 hours before renewal.</li>
          <li>You can manage or cancel your subscription at any time in your account settings.</li>
        </ul>

        <h2>Contact</h2>
        <p>
          Questions about pricing? Email us at{' '}
          <a href="mailto:info@monnaify.com">info@monnaify.com</a>
        </p>

        <div className="legal-actions">
          <Link to="/terms">Terms of Use</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
